import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
export var CheckboxItem = styled.div.withConfig({
  displayName: "partials__CheckboxItem",
  componentId: "sc-87z4ju-0"
})(["display:inline-flex;width:100%;", ";"], minMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth ? '' : 'max-width: 220px;';
}));
export var CheckboxLabel = styled.div.withConfig({
  displayName: "partials__CheckboxLabel",
  componentId: "sc-87z4ju-1"
})(["display:block;color:", ";", ";", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.terciaryDD;
}, textEllipsis, getFont(-1));
export var CheckboxHint = styled.div.withConfig({
  displayName: "partials__CheckboxHint",
  componentId: "sc-87z4ju-2"
})(["color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.terciaryM;
});
export var CheckboxCounter = styled.span.withConfig({
  displayName: "partials__CheckboxCounter",
  componentId: "sc-87z4ju-3"
})(["display:inline;padding-left:6px;margin-left:auto;color:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.terciaryColor;
});
export var CheckboxItemsInner = styled.div.withConfig({
  displayName: "partials__CheckboxItemsInner",
  componentId: "sc-87z4ju-4"
})(["flex-basis:200px;flex-grow:1;margin-bottom:8px;", " ", ";"], function (_ref5) {
  var scrollable = _ref5.scrollable;
  return scrollable ? 'overflow-y: scroll;' : '';
}, minMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref6) {
  var height = _ref6.height,
    scrollable = _ref6.scrollable;
  return !height && scrollable ? "max-height: 220px;" : "max-height: ".concat(height, ";");
}));